/* eslint-disable */
import React, { Component } from 'react';
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import { Redirect } from 'react-router';
import GoogleLogin from 'react-google-login';
import ReactTooltip from 'react-tooltip';
import FacebookLogin from 'react-facebook-login';

import axios from 'axios';
import Aux from './../../hoc/Aux';
import Classes from './LogOut.css';
import logger from './../../logger';
import config from './../../moramma-config.json';
import lang from './../../lang.json';


class LogOut extends Component{ 

    state = {
        redirect: false
    }

    componentDidMount = () => {
        if(!window.location.hash) {
            window.location = window.location + '#loaded';
            window.location.reload();
        }
        else {
            this.setState({redirect: true});
        }
    }


    /**
     * ============================================================================
     *                              RENDER PAGE
     * ============================================================================
     */
    render() {
        if(this.state.redirect === true) {
            return <Redirect to="/" />;
        }
            return (
                <Aux>
                   <p>Log out completed.</p>
            </Aux>
        );
    }
}

export default LogOut;